import React from 'react';
import { ShieldCheck, Award, Download, Lock, CreditCard, Headphones } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Lock,
    text: 'Pago seguro'
  }, {
    icon: Award,
    text: 'Garantía'
  }, {
    icon: Download,
    text: 'Descarga inmediata'
  }, {
    icon: ShieldCheck,
    text: 'Protección de datos'
  }, {
    icon: CreditCard,
    text: 'Tarjetas aceptadas'
  }, {
    icon: Headphones,
    text: 'Soporte 24/7'
  }];
  return <div className="py-8 border-t border-white/10 bg-brand-dark" data-id="element-278">
      <div className="max-w-6xl mx-auto px-4" data-id="element-279">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6" data-id="element-280">
          {items.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} className="flex flex-col items-center text-center opacity-70 hover:opacity-100 transition-opacity" data-id="element-281">
                <Icon className="w-8 h-8 text-gray-400 mb-2" data-id="element-282" />
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-283">
                  {item.text}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}